import React from 'react';

import {
  Table,
  TableCell,
  TableHeader,
  TableRow,
  WrapperFlex,
  Tooltip,
  Card,
} from '@unimed-fesp/components';

import { ImPencil } from 'react-icons/im';

import theme from '../../../styles/theme';

import history from '../../../services/history';

import { HoverActions } from './styles';

function TableParametros({ parametros }) {
  return (
    <>
      <Card maxWidth={1038} flex={1} margin="0">
        <Table head={<TableParametrosHeader />}>
          {parametros.map((parametro) => (
            <TableContentRow
              key={parametro.idParametrizacao}
              parametro={parametro}
            />
          ))}
        </Table>
      </Card>
    </>
  );
}

const TableParametrosHeader = () => {
  return (
    <TableRow>
      <TableHeader>Id</TableHeader>
      <TableHeader>Nome</TableHeader>
      <TableHeader>Descrição</TableHeader>
      <TableHeader>Ativo</TableHeader>
      <TableHeader>Valor</TableHeader>
      <TableHeader>Editar</TableHeader>
    </TableRow>
  );
};

const TableContentRow = ({ parametro }) => {
  return (
    <TableRow>
      <TableCell minWidth={60} maxWidth={60}>
        {parametro.idParametrizacao || '-'}
      </TableCell>
      <TableCell>{parametro.nomeParametrizacao || '-'}</TableCell>
      <TableCell>{parametro.descricao || '-'}</TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {parametro.ativo ? 'ativo' : 'inativo'}
      </TableCell>
      <TableCell>{parametro.valueParametrizacao || '-'}</TableCell>
      <TableCell width={90}>
        <WrapperFlex alignCenter>
          <Tooltip
            background={theme.greenDefault}
            color={theme.bgWhite}
            text="EDITAR"
            position="bottom"
          >
            <HoverActions
              onClick={() =>
                history.push(
                  `/novo/parametros/editar/${parametro.nomeParametrizacao}`,
                  {
                    parametro,
                  }
                )
              }
            >
              <ImPencil size="17" color={theme.colorGray} />
            </HoverActions>
          </Tooltip>
        </WrapperFlex>
      </TableCell>
    </TableRow>
  );
};

export default TableParametros;
